import React, { useEffect, useState } from 'react'
import CryptoJS from 'crypto-js'
import { EncKeys } from '../../../config'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createPaymentRequestData } from '../../redux/actions/ComponentCallsActions'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import {
    Card,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from '@mui/material'
import { PersonPin } from '@mui/icons-material'
import { alertService } from '../../services/alert-service'

const KotakPage = (props) => {
    const dispatch = useDispatch()
    const history = useHistory()

    const key = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey)
    const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV)
    const [maxLength, setMaxLength] = useState(16)
    const paymentData = useSelector((state) => state.customerData)
    const [cardDetails, setCardDetails] = useState({
        month: '',
        year: '',
        cardNumber: '',
        cvv: '',
        cardHolder: '',
    })
    const [cardYears, setcardYears] = useState([])
    const [month, setMonth] = useState(false)
    const [year, setYear] = useState(false)
    const handleMonthChange = ({ target: { name, value } }) => {
        let temp = { ...cardDetails }
        temp.month = value
        setCardDetails(temp)
        if (value === '' || value === undefined) {
            setMonth(false)
        } else {
            setMonth(true)
        }
    }

    const handleYearChange = ({ target: { name, value } }) => {
        let temp = { ...cardDetails }
        temp.year = value
        setCardDetails(temp)
        if (value === '' || value === undefined) {
            setYear(false)
        } else {
            setYear(true)
        }
    }
    const handleChange = ({ target: { name, value } }) => {
        if (name === 'cardHolder') {
            const alphaValue = value.replace(/[^a-zA-Z\s]/g, '')
            let temp = { ...cardDetails }
            temp.cardHolder = alphaValue
            setCardDetails(temp)
        } else if (name === 'cvv') {
            const number = value.replace(/[^0-9]/g, '')
            let temp = { ...cardDetails }
            temp.cvv = number
            setCardDetails(temp)
        } else if (name === 'cardNumber') {
            const filteredValue = value.replace(/[^0-9]/g, '')
            let temp = { ...cardDetails }
            temp.cardNumber = filteredValue
            setCardDetails(temp)
            // Check if the input starts with '3' (as a string)
            if (filteredValue.startsWith('3')) {
                // If it starts with '3', limit the input length to between 14 and 16 characters
                if (filteredValue.length < 14) {
                    let temp = { ...cardDetails }
                    temp.cardNumber = filteredValue.slice(0, 14)
                    setCardDetails(temp)
                    setMaxLength(14)
                } else if (filteredValue.length > 14) {
                    let temp = { ...cardDetails }
                    temp.cardNumber = filteredValue.slice(0, 16)
                    setCardDetails(temp)
                    setMaxLength(16)
                } else if (filteredValue.length !== 16) {
                    let temp = { ...cardDetails }
                    temp.cardNumber = filteredValue.slice(0, 14)
                    setCardDetails(temp)
                    setMaxLength(14)
                } else if (filteredValue.length !== 14) {
                    let temp = { ...cardDetails }
                    temp.cardNumber = filteredValue.slice(0, 16)
                    setCardDetails(temp)
                    setMaxLength(16)
                }
            } else {
                // Otherwise, limit the input length to exactly 16 characters
                let temp = { ...cardDetails }
                temp.cardNumber = filteredValue.slice(0, 16)
                setCardDetails(temp)
                setMaxLength(16)
            }
        } else {
            let temp = { ...cardDetails }
            temp[name] = value
            setCardDetails(temp)
        }
    }
    const getCardYear = () => {
        let years = []
        for (let i = 0; i < 10; i++) {
            let value = new Date().getFullYear() + i
            let text = new Date().getFullYear() + i + ''
            years.push({ value: value, text: text })
        }

        let tempYear = [...years]
        setcardYears(tempYear)
    }
    const SubmitRequest = () => {
        let CardNumber = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(cardDetails.cardNumber.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let Cvv = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(cardDetails.cvv.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let ExpMonth = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(cardDetails.month.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )
        let ExpYear = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(cardDetails.year.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        const postRequest = {
            CustomerPaymentReqID: paymentData.customerData.PaymentRequest.Id,
            AgentID: paymentData.customerData.PaymentRequest.ClientId,
            PaymentOption: 'Kotak',
            TrackId: paymentData.customerData.PaymentRequest.TrackID,
            TotalAmount: paymentData.customerData.PaymentRequest.Amount,
            Cvv: Cvv.toString(),
            ExpiryMonth: ExpMonth.toString(),
            ExpiryYear: ExpYear.toString(),
            CardHolderName: cardDetails.cardHolder,
            CardNo: CardNumber.toString(),
            UDF1: paymentData.customerData.PaymentRequest.UDF1,
            UDF2: paymentData.customerData.PaymentRequest.UDF2,
            UDF3: paymentData.customerData.PaymentRequest.UDF3,
            UDF4: paymentData.customerData.PaymentRequest.UDF4,
            UDF5: paymentData.customerData.PaymentRequest.UDF5,
        }
        const jsonBody = JSON.stringify(postRequest)

        let encryptedPostRequest = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(jsonBody.toString()),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            }
        )

        let postData = {
            payload: encryptedPostRequest.toString(),
        }

        dispatch(
            createPaymentRequestData(
                postData,
                (res) => {
                    if (res.statusCode === 200) {
                        const decryptedResponse = CryptoJS.AES.decrypt(
                            res.data,
                            key,
                            {
                                keySize: 128 / 8,
                                iv: iv,
                                mode: CryptoJS.mode.CBC,
                                padding: CryptoJS.pad.Pkcs7,
                            }
                        )
                        const decrypted = decryptedResponse.toString(
                            CryptoJS.enc.Utf8
                        )
                        localStorage.setItem('gateway', 'Kotak')

                        let actualResponse = JSON.parse(decrypted)
                        console.log(actualResponse)
                        history.push('/KotakCheckout', {
                            responseData: actualResponse,
                        })
                    } else {
                        if (res.errorMessage.includes('VERCARD')) {
                            const errorArray = res.errorMessage.split('-')
                            alertService.addError(errorArray[1])
                        } else {
                            const transactionResponse = {
                                Comments: res.errorMessage,
                                Status: 'Transaction declined',
                                TransactionId: '',
                                TrackId: '',
                                Amount: '',
                                TransactionDate: '',
                                RedirectUrl:
                                    paymentData.customerData.PaymentRequest
                                        .RedirectUrl,
                            }
                            history.push({
                                pathname: '/TransactionStatus',
                                state: transactionResponse,
                            })
                        }
                    }
                },
                (err) => {
                    const transactionResponse = {
                        Comments:
                            'Please Contact Vayana Team for further details',
                        Status: 'Transaction declined',
                        TransactionId: '',
                        TrackId: '',
                        Amount: '',
                        TransactionDate: '',
                        RedirectUrl:
                            paymentData.customerData.PaymentRequest.RedirectUrl,
                    }
                    history.push({
                        pathname: '/TransactionStatus',
                        state: transactionResponse,
                    })
                }
            )
        )
    }
    const handleBack = () => {
        props.onBackBtnClick()
    }
    useEffect(() => {
        getCardYear()
    }, [])

    return (
        <div>
            <ValidatorForm onSubmit={SubmitRequest}>
                <Card sx={{ p: 1, boxShadow: 'none' }}>
                    <Typography
                        style={{
                            padding: '10px 0px',
                        }}
                    >
                        Enter Your Card Details
                    </Typography>

                    <Grid container spacing={1}>
                        <Grid item xs={12} md={6}>
                            <TextValidator
                                size="small"
                                sx={{
                                    width: '100%',
                                    marginTop: '10px',
                                    marginBottom: '22px',
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <PersonPin />
                                        </InputAdornment>
                                    ),
                                }}
                                value={cardDetails.cardHolder || ''}
                                onChange={handleChange}
                                name="cardHolder"
                                id="outlined-basic"
                                label="Card Holder"
                                variant="outlined"
                                validators={['required']}
                                errorMessages={['Card Holder Name is required']}
                                FormHelperTextProps={{
                                    color: 'red',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextValidator
                                size="small"
                                sx={{
                                    width: '100%',
                                    marginTop: '10px',
                                    marginBottom: '22px',
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <img
                                                style={{
                                                    width: '60px',
                                                }}
                                                src="https://www.seekpng.com/png/detail/136-1366945_mastercard-logo-png-logo-visa-mastercard-png.png"
                                                alt="VM"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={handleChange}
                                value={cardDetails.cardNumber || ''}
                                id="outlined-basic"
                                label="Card Number"
                                variant="outlined"
                                maxLength={maxLength}
                                name="cardNumber"
                                validators={[
                                    'required',
                                    `minStringLength:${maxLength}`,
                                    `maxStringLength:${maxLength}`,
                                    'matchRegexp:^[0-9]+$$',
                                ]}
                                errorMessages={[
                                    'Credit-Card Number Name is required',
                                    'Credit-Card Number is not valid',
                                    'Credit Card must be of 16 digits',
                                    'Only numbers are allowed',
                                ]}
                                FormHelperTextProps={{
                                    color: 'red',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl
                                variant="outlined"
                                fullWidth
                                className="mb-4"
                            >
                                <InputLabel
                                    style={{ marginTop: '-5px' }}
                                    id="cardMonthLabel"
                                >
                                    MM
                                </InputLabel>
                                <Select
                                    size="small"
                                    labelId="cardMonthLabel"
                                    id="cardMonth"
                                    label="Month"
                                    value={cardDetails.month || ''}
                                    validators={['required']}
                                    onChange={handleMonthChange}
                                >
                                    <MenuItem value="">
                                        <em>Select Month</em>
                                    </MenuItem>
                                    <MenuItem value="1">
                                        January - (01)
                                    </MenuItem>
                                    <MenuItem value="2">
                                        February - (02)
                                    </MenuItem>
                                    <MenuItem value="3">March - (03)</MenuItem>
                                    <MenuItem value="4">April - (04)</MenuItem>
                                    <MenuItem value="5">May - (05)</MenuItem>
                                    <MenuItem value="6">June - (06)</MenuItem>
                                    <MenuItem value="7">July - (07)</MenuItem>
                                    <MenuItem value="8">August - (08)</MenuItem>
                                    <MenuItem value="9">
                                        September - (09)
                                    </MenuItem>
                                    <MenuItem value="10">
                                        October - (10)
                                    </MenuItem>
                                    <MenuItem value="11">
                                        November - (11)
                                    </MenuItem>
                                    <MenuItem value="12">
                                        December - (12)
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl
                                variant="outlined"
                                fullWidth
                                className="mb-4"
                            >
                                <InputLabel
                                    style={{ marginTop: '-5px' }}
                                    id="cardYearLabel"
                                >
                                    YY
                                </InputLabel>
                                <Select
                                    size="small"
                                    labelId="cardYearLabel"
                                    id="cardYear"
                                    label="Year"
                                    value={cardDetails.year || ''}
                                    validators={['required']}
                                    onChange={handleYearChange}
                                >
                                    {cardYears.map((year) => (
                                        <MenuItem
                                            key={year.value}
                                            value={year.value}
                                        >
                                            {year.text}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <TextValidator
                                size="small"
                                sx={{
                                    width: '100%',

                                    marginBottom: '10px',
                                }}
                                onChange={handleChange}
                                name="cvv"
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <img
                                                style={{
                                                    width: '50px',
                                                }}
                                                src="https://cdn1.iconfinder.com/data/icons/finance-technology-fintech-vol-3/256/cvv-512.png"
                                                alt="CVV"
                                            />
                                        </InputAdornment>
                                    ),
                                }}
                                value={cardDetails.cvv || ''}
                                id="outlined-basic"
                                label="CVV"
                                variant="outlined"
                                type="password"
                                validators={[
                                    'required',
                                    'minStringLength:3',
                                    'maxStringLength:3',
                                ]}
                                errorMessages={[
                                    'CVV is required',
                                    'CVV is not valid',
                                    'CVV must be of 3 digits',
                                ]}
                                FormHelperTextProps={{
                                    color: 'red',
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <button
                                type="button"
                                className="backButton"
                                style={{
                                    width: '100%',
                                    margin: '10px 0px',
                                }}
                                onClick={handleBack}
                            >
                                Back
                            </button>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <button
                                type="submit"
                                className="btn"
                                style={{
                                    backgroundColor:
                                        paymentData.customerData.UIConfig
                                            .ButtonBackgroundColor,
                                    color: paymentData.customerData.UIConfig
                                        .ButtonTextColor,
                                }}
                            >
                                Pay
                            </button>
                        </Grid>
                    </Grid>
                </Card>
            </ValidatorForm>
        </div>
    )
}

export default KotakPage
